import {reduce} from '../lang/array';
import {isEq} from '../lang/is';
import {Source, Stream} from './index';

const
    createMethod = (create = value => value) => {
        const stream = new Source();

        return (
            Object.assign(
                (...values) => {
                    const value = create(...values);

                    stream.next(value);
                    return value;
                },
                {stream}));
    },

    createModel = (initial, ...reducers) => (
        Stream.merge(reducers)
        .scan(
            (state, reducers) => (
                reduce(
                    reducers,
                    (state, {reducer, value}) => reducer(state, value),
                    state)),
            initial)
        .unique(isEq)
        .latest()),

    on = (stream, reducer) => (
        stream.map(
            value => ({
                reducer,
                value
            })));

export {
    createMethod,
    createModel,
    on
};
